<main class="main h-[100vh] overflow-hidden flex flex-col">
    <div class="flex flex-col">
        @if(showOfflineMessage()){
        <p-message severity="error" text="Attention, votre ordinateur semble être hors ligne." variant="text"
            size="large" styleClass="w-full place-items-center" />
        }
    </div>
    <div class="flex flex-row h-full">
        <lgk-sidenav [showSubmenu]="false" displayMode="over" navigationMode="submenu" hideOnLeave [menuItems]="filteredMenu()" >

            <ng-template #header>
                <p-avatar [routerLink]="'user-account'" [label]="userInitials()" shape="circle" size="large" />
            </ng-template>

            <ng-template #footer>
                <div class="text-surface-300">{{version}}</div>
                <div>dev</div>
                <strong class="text-sm/6">Logick</strong>
            </ng-template>
        </lgk-sidenav>
        <div class="h-full w-full bg-surface-100 overflow-none">
            <router-outlet />
        </div>
    </div>
</main>
